import { ChannelsList } from 'ChannelsList'
import { ChannelsTabs } from 'ChannelsTabs'
import { Copyright } from 'Copyright'
import { selectChannelsType } from 'data/selectors'
import { GroupSummary } from 'GroupSummary'
import { Layout } from 'layout'
import Modals from 'modals'
import { OwnersList } from 'OwnersList'
import React from 'react'
import { useSelector } from 'react-redux'
import { SaleTypesList } from 'SaleTypesList'
import { primary } from 'styles'
import { SubListTypeMenu } from 'SubListTypeMenu'
import { TabCountriesList } from 'TabCountriesList'

import Box from '@mui/material/Box'

function Home() {
  const channelsType = useSelector(selectChannelsType)

  return (
    <Layout>
      <div style={{ backgroundColor: primary, paddingBottom: '1.5rem' }}>
        <GroupSummary />
      </div>
      <Box alignItems="baseline" display="flex" justifyContent="space-between">
        <ChannelsTabs />
        <SubListTypeMenu />
      </Box>
      <ChannelsList />
      {channelsType === 'saleTypes' && <SaleTypesList />}
      <OwnersList />
      <TabCountriesList />
      <Copyright />
      <Modals />
    </Layout>
  )
}

export default Home
